export default {
  "nav_signin": "Sign In",
  "nav_account": "Account",
  "nav_signout": "Sign Out",
  "nav_services": "Services",
  "nav_portal": "Portal",
  "nav_credits": "Credits",
  "hero_title": "Smart Digital Solutions",
  "hero_title_line1": "Infinity Business — Smart",
  "hero_title_line2": "Digital Solutions",
  "hero_subtitle": "Meet RisTA, your intelligent digital partner",
  "hero_cta": "Talk to RisTA",
  "hero_cta2": "View Services",
  "hero_online": "Online",
  "hero_digital_partner": "Digital Partner",
  "b2b_title": "Business Solutions (B2B)",
  "p2p_title": "Personal Solutions (P2P)",
  "b2b_desc": "Enterprise web, mobile, software, hosting, design and advertising",
  "p2p_desc": "Smart investment tools and personal growth solutions",
  "business_solutions": "Business Solutions",
  "personal_solutions": "Personal Solutions",
  "enterprise_desc": "Enterprise-grade digital services to grow your business.",
  "personal_desc": "Smart investment tools and education for personal growth.",
  "services_title": "Our Services",
  "services_subtitle": "From enterprise web solutions to personal digital tools. Let RisTA guide you.",
  "services_hero_title": "Our Services",
  "services_hero_desc": "From basic websites to advanced intelligent-system-powered solutions. We deliver digital excellence tailored to your needs.",
  "get_started": "Get Started",
  "get_a_quote": "Get a Quote",
  "free_seo_audit": "Free SEO Audit",
  "ready_to_start": "Ready to Start?",
  "ready_to_build": "Ready to Build Something Amazing?",
  "ready_to_build_sub": "Talk to RisTA to get a personalized quote for your project in minutes.",
  "trusted_worldwide": "Trusted by businesses worldwide",
  "cta_title": "Ready to Build Something Amazing?",
  "cta_subtitle": "Ready to Build Something Amazing? Talk to RisTA...",
  "about": "About",
  "contact": "Contact",
  "privacy": "Privacy Policy",
  "blog": "Blog",
  "donate": "Donate",
  "booking": "Book a Session",
  "login_title": "Welcome Back",
  "register_title": "Create Account",
  "login_subtitle": "Sign in to your Infinity Business account",
  "register_subtitle": "Join Infinity Business today",
  "auth0_btn": "Continue with Auth0",
  "or_email": "or continue with email",
  "email": "Email Address",
  "password": "Password",
  "full_name": "Full Name",
  "signin_btn": "Sign In",
  "register_btn": "Create Account",
  "no_account": "Don't have an account?",
  "have_account": "Already have an account?",
  "create_one": "Create one",
  "sign_in": "Sign in",
  "pricing_title": "Choose Your Plan",
  "pricing_subtitle": "Scale your business with the right plan. All plans include access to RisTA.",
  "pay_stripe": "Pay with Stripe",
  "pay_mypos": "Pay with myPOS",
  "pay_crypto": "Pay with Crypto",
  "free_plan": "Current Free Plan",
  "most_popular": "Most Popular",
  "dashboard_title": "My Account",
  "profile": "Profile",
  "security": "Security (2FA)",
  "subscription": "Subscription",
  "upgrade": "Upgrade",
  "change_plan": "Change Plan",
  "twofa_title": "Two-Factor Authentication",
  "setup_2fa": "Set Up 2FA",
  "disable_2fa": "Disable 2FA",
  "payment_success": "Payment Successful!",
  "payment_cancel": "Payment Cancelled",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. All rights reserved.",
  "about_title": "About Infinity Business",
  "contact_title": "Get In Touch",
  "privacy_title": "Privacy Policy",
  "send_message": "Send Message",
  "trade_title": "We Trade For You",
  "trade_desc": "Professional crypto trading services. Chat with us to learn more and book a session.",
  "back_home": "Back to Home",
  "loading": "Loading...",
  "save": "Save",
  "session_expired": "Your session has expired due to inactivity. Please sign in again.",
  "chat_placeholder": "Type your message...",
  "chat_suggested_1": "I need a website",
  "chat_suggested_2": "Tell me about services",
  "chat_suggested_3": "I want a smart service",
  "chat_suggested_4": "Get a price estimate",
  "trust_platform": "Trusted Platform",
  "trust_security": "Enterprise Security",
  "trust_ai": "Smart Technology",
  "trust_global": "Global Reach",
  "back_to_home": "Back to Home",
  "continue_google": "Continue with Google",
  "continue_facebook": "Continue with Facebook",
  "continue_github": "Continue with GitHub",
  "or_continue_email": "or continue with email",
  "two_factor_auth": "Two-Factor Authentication",
  "enter_2fa_code": "Enter the code from your authenticator app",
  "verify_btn": "Verify Code",
  "verifying": "Verifying...",
  "use_different_account": "Use a different account",
  "session_expired_msg": "Your session has expired due to inactivity. Please sign in again.",
  "nav_home": "Home",
  "nav_back": "Back",
  "my_account": "My Account",
  "sign_out": "Sign Out",
  "client_portal": "Client Portal",
  "your_projects": "Your Projects",
  "your_invoices": "Your Invoices",
  "projects": "Projects",
  "invoices_tab": "Invoices",
  "milestones": "Milestones",
  "messages": "Messages",
  "no_projects": "No projects yet. Your projects will appear here once created by our team.",
  "no_invoices": "No invoices yet.",
  "no_messages": "No messages yet. Start a conversation with the team.",
  "type_message": "Type a message...",
  "back_to_projects": "Back to Projects",
  "budget_label": "Budget",
  "progress_label": "Progress",
  "service_label": "Service",
  "portal_locked_desc": "The Client Portal is available for approved clients. Once you become a paid client, an administrator will grant you access.",
  "contact_to_start": "Contact Us to Get Started",
  "quick_web_dev": "Web Development",
  "quick_mobile": "Mobile App",
  "quick_crypto": "Crypto Education",
  "quick_get_quote": "Get a Quote",
  "quick_tell_more": "Tell me more",
  "quick_have_project": "I have a project",
  "quick_submit": "Submit Request",
  "get_cost_estimate": "Get Cost Estimate",
  "choose_plan": "Choose Your Plan",
  "choose_plan_desc": "Scale your business with the right plan. All plans include access to RisTA.",
  "current_free_plan": "Current Free Plan",
  "svc_ecommerce_label": "E-Commerce / Web Store",
  "svc_ecommerce_desc": "Full online stores with payment integration",
  "svc_seo_label": "SEO & Digital Marketing",
  "svc_seo_desc": "Search engine optimization and growth strategy",
  "svc_hosting_label": "Managed Hosting",
  "svc_hosting_desc": "Secure, fast, and reliable hosting infrastructure",
  "svc_advertising_label": "Digital Advertising",
  "svc_advertising_desc": "PPC, social ads, and performance marketing",
  "svc_trading_label": "Trading Consultation",
  "svc_trading_desc": "Expert-guided trading strategy sessions",
  "svc_domains_label": "Domain Management",
  "svc_domains_desc": "Domain registration, DNS management, and transfers",
  "svc_ecommerce_price": "From €799",
  "svc_seo_price": "From €299/mo",
  "svc_hosting_price": "From €29/mo",
  "svc_advertising_price": "From €499/mo",
  "svc_trading_price": "From €149/session",
  "svc_domains_price": "From €19/yr",
  "testimonials_title": "What Our Clients Say",
  "testimonials_subtitle": "Trusted by businesses across Europe",
  "stat_projects": "Projects Delivered",
  "stat_satisfaction": "Client Satisfaction",
  "stat_languages": "Languages Supported",
  "all_rights_reserved": "All rights reserved.",
  "privacy_heading": "Privacy Policy",
  "privacy_last_updated": "Last Updated: March 7, 2026",
  "privacy_intro": "Infinity Business (\"we\", \"us\", \"our\"), operated by Liber Nostra d.o.o., is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.",
  "privacy_s1_title": "1. Information We Collect",
  "privacy_s2_title": "2. How We Use Your Information",
  "privacy_s3_title": "3. Data Sharing",
  "privacy_s4_title": "4. Data Security",
  "privacy_s5_title": "5. Your Rights",
  "privacy_s6_title": "6. Cookies & Tracking",
  "privacy_s7_title": "7. Data Retention",
  "privacy_s8_title": "8. International Transfers",
  "privacy_s9_title": "9. Changes to This Policy",
  "privacy_s10_title": "10. Contact Us",
  "terms_heading": "Terms and Conditions",
  "terms_last_updated": "Last updated: February 2026",
  "terms_s1_title": "1. Introduction",
  "terms_s2_title": "2. Services",
  "terms_s3_title": "3. User Accounts",
  "terms_s4_title": "4. Payments and Billing",
  "terms_s5_title": "5. Intelligent Services Disclaimer",
  "terms_s6_title": "6. Intellectual Property",
  "terms_s7_title": "7. Privacy and Data",
  "terms_s8_title": "8. Cryptocurrency Disclaimer",
  "terms_s9_title": "9. Limitation of Liability",
  "terms_s10_title": "10. Modifications",
  "terms_s11_title": "11. Governing Law",
  "terms_s12_title": "12. Contact",
  "about_heading": "About Infinity Business",
  "about_intro": "We are a technology company focused on delivering intelligent digital solutions. Founded in 2026, Infinity Business combines intelligent innovation with proven expertise to help businesses and individuals thrive in the digital economy.",
  "about_values": "Our Values",
  "about_what_we_do": "What We Do",
  "about_meet_rista": "Meet RisTA",
  "about_rista_desc": "RisTA is our intelligent digital assistant and partner, powered by the latest intelligent system models. RisTA helps qualify your project requirements, provides instant guidance on our services, and connects you with our team of professionals. Available 24/7, RisTA speaks multiple languages and adapts to your needs.",
  "about_talk_rista": "Talk to RisTA",
  "about_val_trust": "Trust & Security",
  "about_val_trust_desc": "We employ the highest standards of data protection and security practices to safeguard your business.",
  "about_val_innovation": "Innovation",
  "about_val_innovation_desc": "Cutting-edge intelligent technology drives our solutions, keeping you ahead of the competition.",
  "about_val_partnership": "Partnership",
  "about_val_partnership_desc": "We work alongside you as a true partner, not just a service provider.",
  "about_val_global": "Global Reach",
  "about_val_global_desc": "Our solutions are designed for international markets with multi-language support.",
  "about_svc_web": "Web Development",
  "about_svc_web_desc": "Full-stack web applications, e-commerce platforms, and custom CMS solutions.",
  "about_svc_mobile": "Mobile Applications",
  "about_svc_mobile_desc": "Native and cross-platform mobile apps for iOS and Android.",
  "about_svc_software": "Custom Software",
  "about_svc_software_desc": "Tailored software solutions to automate and optimize your business processes.",
  "about_svc_invest": "Smart Investments",
  "about_svc_invest_desc": "Intelligent crypto and DeFi tools with professional trading services.",
  "walkthrough_heading": "Walkthroughs",
  "walkthrough_gmail": "Gmail Smart Assistant",
  "walkthrough_gmail_desc": "See how RisTA organizes your inbox",
  "walkthrough_calendar": "Personal Advisor",
  "walkthrough_calendar_desc": "Calendar, to-dos, and email via chat",
  "walkthrough_ai": "Intelligent System Services",
  "walkthrough_ai_desc": "Resume, business plans, brand kits & more",
  "form_your_name": "Your Name",
  "form_your_email": "Your Email",
  "form_describe_need": "Describe what you need...",
  "form_additional_feedback": "Any additional feedback? (optional)",
  "form_email_followup": "Your email (optional, for follow-up)",
  "form_budget_range": "Budget Range",
  "form_timeline": "Timeline",
  "form_cancel": "Cancel",
  "form_select_services": "Select services (multiple allowed):",
  "estimate_title": "Project Cost Estimate",
  "estimate_service": "Service",
  "estimate_complexity": "Complexity",
  "estimate_base_price": "Base Price",
  "estimate_cost": "Estimated Cost",
  "estimate_features": "Key Features",
  "estimate_accept": "Accept & Submit",
  "estimate_revise": "Revise",
  "generating_estimate": "Generating cost estimate...",
  "rating_title": "Rate Your Experience with RisTA",
  "rating_helpful": "How helpful was this conversation?",
  "rating_overall": "Overall assistant experience",
  "rating_recommend": "Would you recommend RisTA?",
  "rating_yes": "Yes",
  "rating_no": "No",
  "rating_submit": "Submit Rating",
  "rating_skip": "Skip",
  "rating_thanks": "Thank you for your feedback!",
  "submit_service_request": "Submit Your Service Request",
  "profile_info": "Profile Information",
  "profile_name": "Name",
  "profile_email": "Email",
  "profile_role": "Role",
  "profile_member_since": "Member Since",
  "profile_admin_dashboard": "Open Admin Dashboard",
  "profile_rerun_onboarding": "Re-run Onboarding Wizard",
  "profile_language_pref": "Preferred Language",
  "profile_language_saved": "Language preference saved!",
  "services_cta_title": "Ready to Start?",
  "services_cta_desc": "Talk to RisTA, our intelligent digital assistant, to get a personalized quote for your project.",
  "services_talk_rista": "Talk to RisTA",
  "services_free_audit": "Free SEO Audit",
  "nav_tools": "Tools",
  "nav_marketplace": "Marketplace",
  "chat_digital_partner": "Digital Partner",
  "chat_online": "Online",
  "chat_help_text": "I can help with web dev, mobile apps, design, crypto & more.",
  "chat_your_partner": "Your Digital Partner",
  "chat_assistant_subtitle": "Chat with your intelligent assistant",
  "tab_password": "Password",
  "tab_rista_services": "RisTA Services",
  "tab_analytics": "Analytics",
  "tab_projects": "Projects",
  "tab_referral": "Referral Program",
  "marketplace_title": "Template Marketplace",
  "marketplace_subtitle": "Premium templates you can customize. Professional quality, ready to use.",
  "marketplace_search": "Search templates...",
  "marketplace_purchase": "Purchase",
  "marketplace_preview": "Preview",
  "marketplace_all": "All",
  "marketplace_category_website": "Website",
  "marketplace_category_brand": "Brand",
  "marketplace_category_resume": "Resume",
  "marketplace_downloads": "downloads",
  "marketplace_close_preview": "Close Preview",
  "marketplace_features": "Features",
  "marketplace_live_preview": "Live Preview",
  "case_studies_title": "Client Success Stories",
  "case_studies_subtitle": "Real results from real businesses. See the transformation.",
  "case_studies_before": "Before",
  "case_studies_after": "After",
  "case_studies_cta_title": "Ready to Grow Your Business?",
  "case_studies_cta_desc": "Join these businesses and see similar results with our intelligent services.",
  "case_studies_cta_btn": "Get Started",
  "profile_go_homepage": "Go to Homepage",
  "onboarding_welcome_title": "Welcome to Infinity Business",
  "onboarding_welcome_subtitle": "Your intelligent digital partner",
  "onboarding_welcome_content": "Infinity Business offers comprehensive B2B and P2P digital services. Our intelligent assistant RisTA will guide you through everything you need.",
  "onboarding_welcome_item1": "Intelligent project estimation & 20+ micro-tools",
  "onboarding_welcome_item2": "Web, mobile, design, and digital marketing services",
  "onboarding_welcome_item3": "Crypto tools, DeFi solutions & investment platform",
  "onboarding_welcome_item4": "Subscription plans: Basic (29 EUR), Premium (79 EUR), Lifetime (499 EUR)",
  "onboarding_services_title": "Explore Our Services",
  "onboarding_services_subtitle": "Two categories tailored for you",
  "onboarding_services_content": "We offer two categories of services:",
  "onboarding_services_item1": "B2B: Web development, mobile apps, graphic design, hosting, custom software, ads, API access",
  "onboarding_services_item2": "P2P: Crypto education, DeFi solutions, domain market, managed trading, digital tools",
  "onboarding_services_item3": "Intelligent System Micro-Tools: Market snapshots, competitor analysis, email generators, blog outlines, TAM calculators, and more",
  "onboarding_services_item4": "Talk to RisTA anytime for personalized quotes and service recommendations",
  "onboarding_credits_title": "Credit System",
  "onboarding_credits_subtitle": "Prepaid balance for smart services",
  "onboarding_credits_content": "Use credits to instantly access our smart services:",
  "onboarding_credits_item1": "1 EUR = 1 credit. Basic plan: 29 credits, Premium: 79, Lifetime: 499",
  "onboarding_credits_item2": "Free tools available without credits. Paid micro-tools cost $1 each",
  "onboarding_credits_item3": "Bulk discounts: 5% at 50+ EUR, 10% at 100+ EUR, 15% at 250+ EUR, 20% at 500+ EUR",
  "onboarding_credits_item4": "Top up with Card, PayPal, myPOS, or Crypto from the Credits panel",
  "onboarding_chat_title": "Talk to RisTA",
  "onboarding_chat_subtitle": "Your digital partner is ready",
  "onboarding_chat_content": "RisTA can help you with:",
  "onboarding_chat_item1": "Getting project estimates and quotes",
  "onboarding_chat_item2": "Exploring service options in detail",
  "onboarding_chat_item3": "Submitting service requests",
  "onboarding_chat_item4": "Answering questions in 11 languages",
  "onboarding_next": "Next",
  "onboarding_get_started": "Get Started",
  "onboarding_back": "Back",
  "onboarding_biz_title": "Service Selection",
  "onboarding_biz_subtitle": "What best describes your needs?",
  "onboarding_biz_content": "Help us recommend the right services for you:",
  "onboarding_biz_type_startup": "Startup / New Business",
  "onboarding_biz_type_smb": "Small-Medium Business",
  "onboarding_biz_type_enterprise": "Enterprise / Corporation",
  "onboarding_biz_type_freelancer": "Freelancer / Individual",
  "onboarding_biz_type_investor": "Investor / Crypto Enthusiast",
  "hosting_title": "Hosting Packages",
  "hosting_subtitle": "Reliable, fast hosting for your business",
  "developer_title": "Developer API",
  "developer_subtitle": "Integrate our intelligent services into your applications",
  "tools_title": "Free Marketing Tools",
  "tools_subtitle": "Try our free tools — no sign-up required",
  "referral_title": "Referral Program",
  "referral_subtitle": "Invite friends and earn rewards",
  "referral_generate": "Generate My Referral Code",
  "referral_redeem_title": "Redeem a Code",
  "referral_redeem_btn": "Redeem",
  "referral_referrals": "Referrals",
  "referral_rewards": "Rewards",
  "referral_copy_link": "Copy Link",
  "referral_copied": "Copied!",
  "project_tracker_title": "Project Tracker",
  "project_no_projects": "No projects yet. Projects will appear here once you purchase a service.",
  "analytics_total_services": "Total Services",
  "analytics_completed": "Completed",
  "analytics_pending": "Pending",
  "analytics_total_spent": "Total Spent",
  "analytics_credit_balance": "Credit Balance",
  "analytics_subscription": "Subscription",
  "analytics_recent": "Recent Services",
  "change_password_title": "Change Password",
  "change_password_current": "Current Password",
  "change_password_new": "New Password",
  "change_password_confirm": "Confirm New Password",
  "change_password_btn": "Change Password",
  "change_password_social": "Password change is not available for social login accounts.",
  "billing_management": "Billing Management",
  "billing_manage_desc": "Manage your payment methods, view invoices, or update your billing details through the Stripe portal.",
  "billing_manage_btn": "Manage Billing",
  "billing_cancel_btn": "Cancel Plan",
  "plan_features": "Your Plan Features",
  "nav_try_free": "Try Free",
  "profile_appearance": "Appearance & Accessibility",
  "profile_theme": "Theme",
  "profile_text_size": "Text Size",
  "profile_text_size_hint": "Adjust text size for easier reading.",
  "try_free_title": "Free Tools & Trial Services",
  "try_free_subtitle": "No credit card required. Start using our tools right away.",
  "try_free_section": "Completely Free — No Account Needed",
  "try_free_trial_section": "Intelligent System Services — Try with Credits",
  "try_free_trial_desc": "Sign up for a plan to get credits, then use them to access these smart services.",
  "try_free_cta": "Ready to Get Started?",
  "try_free_cta_desc": "Create a free account to get your first credits and unlock all smart services.",
  "try_free_cta_btn": "Sign Up Free",
  "review_title": "What Our Clients Say",
  "review_subtitle": "Real feedback from businesses we've helped",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_1_text": "RisTA helped us build our entire web presence in just 2 weeks. The intelligent consultation was incredibly accurate in understanding our needs.",
  "testimonial_2_role": "Marketing Director, BioFresh",
  "testimonial_2_text": "The brand kit and social media calendar services saved us months of work. The quality exceeded what we got from traditional agencies.",
  "testimonial_3_role": "Freelance Developer",
  "testimonial_3_text": "I use the resume builder and competitor analysis tools regularly. The intelligent output is production-ready and the credit system makes pricing transparent.",
  "sp_basic_web_name": "Basic Website Creation",
  "sp_basic_web_desc": "Professional website for your business with modern design and full mobile compatibility.",
  "sp_basic_web_feat": "Modern responsive design|Up to 5 pages|Contact form integration|Mobile-optimized|Basic SEO setup|Content input assistance",
  "sp_web_store_name": "Web Store / E-Commerce",
  "sp_web_store_desc": "Full-featured e-commerce platform with integrated payments and marketing tools.",
  "sp_web_store_feat": "Complete online store|Payment processing|Product management|Order tracking|SEO optimization|Marketing strategy included",
  "sp_custom_web_name": "Custom Web Application",
  "sp_custom_web_desc": "Tailored web applications built to your exact business requirements.",
  "sp_custom_web_feat": "Custom software design|API integrations|Database architecture|Scalable infrastructure|Admin dashboards|Ongoing support",
  "sp_mobile_app_name": "Mobile Application",
  "sp_mobile_app_desc": "Native and cross-platform mobile applications for iOS and Android.",
  "sp_mobile_app_feat": "iOS & Android|Cross-platform development|Push notifications|App store submission|UI/UX design|Backend integration",
  "sp_seo_name": "SEO & Digital Marketing",
  "sp_seo_desc": "Boost your online visibility with comprehensive SEO and digital marketing strategies.",
  "sp_seo_feat": "Full SEO audit|Keyword optimization|Content strategy|Google Ads management|Social media marketing|Monthly reports",
  "sp_graphic_name": "Graphic Design & Branding",
  "sp_graphic_desc": "Complete branding and graphic design solutions for your business identity.",
  "sp_graphic_feat": "Logo design|Brand identity|Marketing materials|Social media graphics|Print design|Style guide",
  "sp_vector_gen_name": "Smart Vector Generator",
  "sp_vector_gen_desc": "Generate production-ready SVG vector graphics from text descriptions with smart technology.",
  "sp_vector_gen_feat": "Text-to-vector generation|SVG & PNG export|Multiple style presets|Inline SVG editor|Reference file upload|Credit-based pricing",
  "sp_crypto_edu_name": "Crypto Education Program",
  "sp_crypto_edu_desc": "Learn cryptocurrency trading and blockchain technology from industry experts.",
  "sp_crypto_edu_feat": "Blockchain fundamentals|Trading strategies|Wallet security|DeFi introduction|Market analysis|Personal mentoring",
  "sp_invest_name": "Smart Investment Tools",
  "sp_invest_desc": "Professional investment tracking and analysis tools powered by intelligent systems.",
  "sp_invest_feat": "Portfolio tracker|Market dashboard|Smart insights|Risk assessment|Real-time alerts|Multi-exchange support",
  "sp_ad_name": "Advertisement Services",
  "sp_ad_desc": "Reach millions through our extensive portal network across multiple regions.",
  "sp_ad_feat": "20+ portal network|10M+ reach|Targeted campaigns|Performance tracking|Multi-platform ads|ROI optimization",
  "contact_heading": "Get In Touch",
  "contact_subtitle_text": "Have a question or want to discuss a project? We'd love to hear from you.",
  "contact_name_label": "Name",
  "contact_email_label": "Email",
  "contact_subject_label": "Subject",
  "contact_message_label": "Message",
  "contact_name_ph": "Your name",
  "contact_email_ph": "you@example.com",
  "contact_subject_ph": "What's this about?",
  "contact_message_ph": "Tell us about your project or question...",
  "contact_send_btn": "Send Message",
  "contact_sending": "Sending...",
  "contact_sent_title": "Message Sent!",
  "contact_sent_msg": "Thank you for reaching out. We'll get back to you within 24 hours.",
  "contact_send_another": "Send another message",
  "contact_info_email": "Email",
  "contact_info_location": "Location",
  "contact_info_eu": "European Union",
  "contact_info_response": "Response Time",
  "contact_info_response_time": "Within 24 hours",
  "contact_info_hours": "Mon - Fri, 9:00 - 18:00 CET",
  "tf_seo_name": "Free SEO Audit",
  "tf_seo_desc": "Get a comprehensive SEO analysis of any website - no account required.",
  "tf_color_name": "Color Palette Generator",
  "tf_color_desc": "Generate beautiful, harmonious color palettes for your brand.",
  "tf_headline_name": "Headline Analyzer",
  "tf_headline_desc": "Score your headlines for click-through potential and emotional impact.",
  "tf_chat_name": "Chat with RisTA",
  "tf_chat_desc": "Get instant project estimates, explore services, and ask questions in 11 languages.",
  "tf_free_label": "Free",
  "tools_seo_title": "SEO Quick Checker",
  "tools_seo_desc": "Instant SEO score for any website",
  "tools_seo_ph": "Enter website URL (e.g. example.com)",
  "tools_analyze": "Analyze",
  "tools_color_title": "Color Palette Generator",
  "tools_color_desc": "Generate complementary color palettes",
  "tools_headline_title": "Headline Analyzer",
  "tools_headline_desc": "Analyze headline effectiveness",
  "tools_headline_ph": "Enter your headline...",
  "tools_headline_btn": "Analyze Headline",
  "tools_issues": "Issues Found",
  "tools_suggestions": "Suggestions",
  "tools_score": "Score",
  "docs_heading": "Platform Features",
  "docs_subtitle": "Everything Infinity Business offers to help your digital journey.",
  "docs_no_data": "No documentation available.",
  "tester_heading": "Become a Tester",
  "tester_subtitle": "Help us improve the platform and get free access to intelligent system services.",
  "tester_req_title": "What's Required",
  "tester_req_1": "Log in at least 5 times per week",
  "tester_req_2": "Submit at least 10 bug/feedback reports per week",
  "tester_req_3": "Test different features, pages, and user flows",
  "tester_benefit_title": "What You Get",
  "tester_benefit_1": "Free access to intelligent system services (based on requests)",
  "tester_benefit_2": "Tester dashboard with progress tracking",
  "tester_benefit_3": "Priority support from the team",
  "tester_apply_title": "Apply to Join",
  "tester_motivation": "Why do you want to be a tester?",
  "tester_motivation_ph": "Tell us why you'd like to help test the platform...",
  "tester_experience": "Testing experience (optional)",
  "tester_experience_ph": "Any relevant experience...",
  "tester_submit_app": "Submit Application",
  "tester_applied_title": "Application Submitted",
  "tester_applied_msg": "Our admin will review your application and you'll be notified.",
  "tester_need_account": "You need an account to apply.",
  "tester_dash_title": "Tester Dashboard",
  "tester_dash_desc": "Keep your tester status active by meeting weekly targets.",
  "tester_weekly_logins": "Weekly Logins",
  "tester_weekly_reports": "Weekly Reports",
  "tester_target_met": "Target met!",
  "tester_logins_needed": "more logins needed this week",
  "tester_reports_needed": "more reports needed this week",
  "tester_total_reports": "Total reports submitted",
  "tester_on_track": "On Track",
  "tester_at_risk": "At Risk",
  "tester_report_heading": "Submit Bug / Feedback Report",
  "tester_report_title_ph": "Title (e.g. 'Button not clickable on mobile')",
  "tester_report_desc_ph": "Describe the issue or suggestion in detail...",
  "tester_report_page_ph": "Page URL (optional)",
  "tester_submit_report": "Submit Report",
  "seo_page_title": "Free SEO Audit",
  "seo_page_desc": "Enter any website URL to get a comprehensive SEO analysis with actionable recommendations.",
  "seo_page_ph": "Enter website URL (e.g. example.com)",
  "seo_page_btn": "Run Audit",
  "seo_page_running": "Analyzing...",
  "seo_page_error": "Failed to audit this website. Please check the URL and try again.",
  "referral_reward_title": "Referral Rewards",
  "referral_reward_desc": "Earn 10% of every purchase made by users you refer, delivered as system free credits. The more friends you bring, the more you earn!",
  "referral_reward_1": "Share your unique referral link with friends",
  "referral_reward_2": "When they make a purchase, you earn 10% as free credits",
  "referral_reward_3": "Credits are added automatically to your balance",
  "referral_earned_label": "Credits Earned",
  "profile_picture": "Profile Picture",
  "profile_bio": "Bio",
  "profile_website": "Website",
  "profile_interests": "Interests",
  "profile_upload_photo": "Upload Photo",
  "profile_bio_ph": "Tell us about yourself...",
  "profile_website_ph": "https://yourwebsite.com",
  "profile_interests_ph": "Web development, crypto, design...",
  "profile_save": "Save Profile",
  "admin_notes": "Admin Notes",
  "admin_notes_ph": "Add a note about this user...",
  "admin_notes_add": "Add Note",
  "sub_most_popular": "Most Popular",
  "sub_free": "Free",
  "sub_one_time": "one-time",
  "sub_team_members": "Team Members",
  "sub_members_info": "Invite team members to share your plan. Each member gets their own login and access to services under your subscription.",
  "sub_show_less": "Show less",
  "sub_more_features": "more features",
  "sub_pay_with": "Pay with",
  "sub_preferred": "preferred",
  "sub_live_crypto": "Live Crypto Prices (EUR & USD)",
  "profile_change_avatar": "Change Avatar",
  "profile_about": "About You",
  "profile_interests_hint": "Separate interests with commas",
  "sp_logo_name": "Logo Design",
  "sp_logo_desc": "Professional custom logo design that captures your brand essence and stands out from the competition.",
  "sp_logo_feat": "3 unique concepts|Unlimited revisions|Vector files (AI, SVG, PDF)|Full color + B&W versions|Brand guidelines document|Social media kit",
  "sp_brand_name": "Full Brand Identity",
  "sp_brand_desc": "Complete brand identity package including logo, color palette, typography, and brand guidelines for a consistent professional image.",
  "sp_brand_feat": "Logo design|Color palette|Typography selection|Business card design|Letterhead & envelope|Brand guidelines PDF|Social media templates",
  "sp_poster_name": "Poster Design",
  "sp_poster_desc": "Eye-catching poster designs for events, promotions, or advertising campaigns that grab attention and drive results.",
  "sp_poster_feat": "Custom illustration|Print-ready files|Multiple sizes|2 revision rounds|High-res output|Digital + print formats",
  "sp_flyer_name": "Flyer Design",
  "sp_flyer_desc": "Professional flyer designs for marketing, events, and promotions. Both digital and print-ready formats included.",
  "sp_flyer_feat": "Front & back design|Print-ready PDF|Digital version|QR code integration|2 revision rounds|Multiple formats",
  "sp_menu_name": "Menu Design",
  "sp_menu_desc": "Beautiful restaurant and cafe menu designs that showcase your offerings and enhance the dining experience.",
  "sp_menu_feat": "Custom layout|Food photography integration|QR code version|Print-ready files|Seasonal update option|Multiple pages",
  "currency_label": "Currency",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "admin_overview": "Overview",
  "admin_my_account": "My Account",
  "admin_health": "Health Monitor",
  "admin_analytics": "Analytics",
  "admin_integrations": "Integrations",
  "admin_requests": "Service Requests",
  "admin_high_value": "High-Value Leads",
  "admin_followups": "Follow-up Emails",
  "admin_ratings": "Ratings & Feedback",
  "admin_users": "User Management",
  "admin_crypto_payments": "Crypto Payments",
  "admin_bug_reports": "Bug Reports",
  "admin_pricing": "Dynamic Pricing",
  "admin_pricing_tiers": "Pricing Tiers",
  "admin_package_mgr": "Package Manager",
  "admin_defi": "DeFi Items",
  "admin_chat_sessions": "Chat Sessions",
  "admin_language_requests": "Language Requests",
  "admin_notifications": "Notifications",
  "admin_sendgrid": "Email (SendGrid)",
  "admin_ai_config": "Model Config",
  "admin_llm_usage": "LLM Key Usage",
  "admin_live_analytics": "Live Analytics",
  "admin_system_config": "System Config",
  "admin_backup": "Backup & Restore",
  "admin_referrals": "Referral Program",
  "admin_invoices": "Invoicing",
  "admin_billing": "Recurring Billing",
  "admin_blog": "Blog Manager",
  "admin_logo": "Logo & Favicon",
  "admin_promo": "Promo Codes",
  "admin_currency": "Multi-Currency",
  "admin_domain": "Domain Manager",
  "admin_cdn": "CDN Manager",
  "admin_social": "Social Media",
  "admin_avatar_selector": "Avatar Selector",
  "admin_avatar_builder": "Avatar Builder",
  "admin_client_portal": "Client Portal",
  "admin_abandoned_carts": "Abandoned Carts",
  "rista_login_required": "Login Required",
  "rista_login_desc": "Log in or create an account to chat with RisTA and get personalized business recommendations.",
  "rista_login_btn": "Log In",
  "rista_signup_btn": "Sign Up",
  "admin_high_leads": "High-Priority Leads",
  "admin_surveys": "Satisfaction Surveys",
  "admin_rista": "RisTA Services",
  "admin_docs": "Documentation",
  "admin_audit": "Platform Audit",
  "admin_kb": "Knowledge Base",
  "admin_reports": "Admin Reports",
  "admin_ad_gen": "Ad Generator",
  "admin_service_mgr": "Service Manager",
  "admin_project_delivery": "Project Delivery",
  "admin_tester": "Tester Program",
  "admin_credits": "Credit Config",
  "admin_account_mgmt": "Account Management",
  "admin_payment_opts": "Payment Options",
  "admin_lead_tracking": "Lead Tracking",
  "admin_demo": "Demo Access",
  "admin_crypto_trading": "Crypto Trading",
  "admin_auto_posting": "Smart Auto-Posting",
  "admin_fb": "FB Analytics",
  "admin_referral_board": "Referral Leaderboard",
  "admin_referral_tree": "Referral Network",
  "admin_escalations": "Chat Escalations",
  "admin_portfolio": "Portfolio Manager",
  "admin_email_templates": "Email Templates",
  "admin_social_icons": "Social Icons",
  "admin_ai_prompts": "Smart Prompts",
  "admin_panel": "Admin Panel",
  "admin_sign_out": "Sign Out",
  "admin_search_tabs": "Search tabs...",
  "admin_demo_banner": "READ-ONLY MODE - Demo Viewer Account (All user data is masked)",
  "admin_system_admin": "SYSTEM ADMIN",
  "admin_loading": "Loading...",
  "admin_no_matching": "No matching tabs",
  "nav_currency": "Currency",
  "nav_orders": "My Orders",
  "micro_tools_title": "Smart Micro-Tools",
  "micro_tools_subtitle": "Instant Smart insights for lead generation, market research, email outreach, and strategic planning.",
  "micro_tools_all": "All",
  "micro_tools_try": "Try it",
  "micro_tools_generate_free": "Generate (Free)",
  "micro_tools_generate_paid": "Generate",
  "micro_tools_close": "Close",
  "micro_tools_interested": "Interested?",
  "tools_view_service": "View Service",
  "tools_talk_rista": "Talk to RisTA",
  "competitor_title": "Smart Competitor Analysis",
  "competitor_desc": "Enter a competitor URL and get an intelligent analysis with SEO comparison, design review, and content gaps.",
  "competitor_url_ph": "Enter competitor URL (e.g. competitor.com)",
  "competitor_analyze": "Analyze Competitor",
  "competitor_score": "Overall Score",
  "competitor_seo": "SEO Analysis",
  "competitor_design": "Design Analysis",
  "competitor_content": "Content Analysis",
  "competitor_strengths": "Strengths",
  "competitor_weaknesses": "Weaknesses",
  "competitor_opportunities": "Opportunities",
  "competitor_recommendations": "Recommendations",
  "accessibility_title": "Accessibility Check",
  "accessibility_desc": "Check website accessibility standards compliance",
  "cat_lead_gen": "Lead-Gen & Traffic",
  "cat_discovery": "Report Discovery",
  "cat_email": "Email & Workflow",
  "cat_planning": "Planning & Strategy",
  "cat_content": "Content & Positioning",
  "profile_country": "Country",
  "profile_country_ph": "e.g. Germany, Croatia, United States",
  "health_title": "Website Health Score",
  "health_desc": "Comprehensive analysis of your website's SEO, performance, security, and accessibility in one dashboard.",
  "health_premium_badge": "Premium Feature",
  "health_url_ph": "Enter website URL (e.g. example.com)",
  "health_scan_btn": "Scan",
  "health_scanning": "Scanning...",
  "health_scan_error": "Failed to scan website. Please check the URL.",
  "health_overall": "Overall Health Score",
  "health_response": "Response",
  "health_size": "Size",
  "health_seo": "SEO",
  "health_perf": "Performance",
  "health_security": "Security",
  "health_a11y": "Accessibility",
  "health_history": "Scan History",
  "health_login_required": "Sign in to use Health Score",
  "health_login_desc": "Create a free account to scan your website and track improvements over time.",
  "health_upsell_title": "Want recurring monitoring?",
  "health_upsell_desc": "Upgrade to Premium for automated weekly scans, email alerts, and trend tracking across all your websites.",
  "health_upgrade_btn": "Upgrade to Premium",
  "seo_cta_title": "Need help fixing these issues?",
  "seo_cta_desc": "Our intelligent SEO audit covers 100+ checkpoints. Get professional help optimizing your website.",
  "admin_image_gen": "Image Generation",
  "admin_health_score": "Health Score",
  "admin_ai_reports": "AI Service Reports",
  "nav_health_score": "Health Score",
  "admin_new": "new",
  "admin_score": "Score",
  "admin_avg_rating": "Avg Rating",
  "admin_avg_exp": "Avg Experience",
  "admin_reviews": "reviews",
  "admin_out_of": "Out of",
  "admin_total": "Total",
  "admin_unread": "Unread",
  "admin_active": "Active",
  "admin_pending": "Pending",
  "admin_save": "Save",
  "admin_cancel": "Cancel",
  "admin_delete": "Delete",
  "admin_edit": "Edit",
  "admin_status": "Status",
  "admin_actions": "Actions",
  "admin_created": "Created",
  "admin_updated": "Updated",
  "admin_view_all": "View All",
  "admin_no_data": "No data available",
  "a11y_checker": "Accessibility Audit",
  "a11y_rescan": "Re-scan",
  "a11y_scanning": "Running WCAG audit...",
  "a11y_compliant": "Compliant",
  "a11y_passed": "passed",
  "a11y_violations": "violations",
  "a11y_incomplete": "needs review",
  "a11y_issues_found": "Issues Found",
  "a11y_no_issues": "No accessibility issues found!",
  "a11y_disclaimer": "Automated checks cover ~30% of accessibility issues. Manual testing with screen readers is recommended.",
  "a11y_error": "Audit failed. Please try again.",
  "admin_timeline": "Project Timeline",
  "admin_add_milestone": "Add Milestone",
  "admin_milestone_title": "Milestone title",
  "admin_milestone_desc": "Description (optional)",
  "admin_no_milestones": "No milestones yet. Add your first one!",
  "status_planned": "Planned",
  "status_in_progress": "In Progress",
  "status_completed": "Completed",
  "status_blocked": "Blocked",
  "priority_low": "Low",
  "priority_medium": "Medium",
  "priority_high": "High",
  "priority_critical": "Critical",
  "admin_email_templates_desc": "Customize email templates with the visual block editor.",
  "admin_preloader": "Preloader Config",
  "sp_health_score": "Website Health Score",
  "sp_health_score_desc": "Comprehensive website analysis covering SEO, performance, security, and accessibility compliance.",
  "sp_health_score_name": "Website Health Score",
  "sp_health_score_feat": "SEO analysis|Performance check|Security scan|Accessibility audit|Detailed report|Improvement tips",
  "sp_hosting_name": "Managed Web Hosting",
  "sp_hosting_desc": "Secure, fast, and reliable hosting infrastructure for your websites and applications.",
  "sp_hosting_feat": "99.9% uptime|SSL certificates|Daily backups|CDN integration|24/7 monitoring|Auto-scaling",
  "sp_biz_plan_name": "Smart Business Plan",
  "sp_biz_plan_desc": "Generate a comprehensive business plan with financials, market analysis, and growth strategy.",
  "sp_biz_plan_feat": "Executive summary|Market analysis|Financial projections|Competitor overview|Growth strategy|Investor-ready format",
  "sp_seo_report_name": "Website Audit Report",
  "sp_seo_report_desc": "Automated site analysis with actionable SEO recommendations and performance insights.",
  "sp_seo_report_feat": "100+ checkpoints|Performance metrics|SEO recommendations|Mobile analysis|Security review|Action plan",
  "sp_email_campaign_name": "Email Marketing Setup",
  "sp_email_campaign_desc": "Professional email campaign setup with copy, sequences, and audience targeting.",
  "sp_email_campaign_feat": "Email copy writing|Sequence setup|Audience targeting|A/B testing|Analytics setup|Template design",
  "sp_competitor_name": "Competitor Analysis",
  "sp_competitor_desc": "Deep competitive intelligence with SEO comparison, design review, and content gap analysis.",
  "sp_competitor_feat": "SEO comparison|Design review|Content gaps|Market positioning|SWOT analysis|Strategy recommendations",
  "sp_legal_docs_name": "Legal Document Generator",
  "sp_legal_docs_desc": "Professional legal templates including NDA, contracts, and Terms of Service.",
  "sp_legal_docs_feat": "NDA templates|Service contracts|Terms of Service|Privacy policies|GDPR compliance|Custom clauses",
  "sp_resume_name": "Smart Resume Builder",
  "sp_resume_desc": "Create ATS-optimized resumes tailored to your target role and industry.",
  "sp_resume_feat": "ATS optimization|Industry templates|Keyword matching|Cover letter|LinkedIn optimization|PDF export",
  "sp_brand_kit_name": "Smart Logo & Brand Kit",
  "sp_brand_kit_desc": "Complete brand identity package with logo concepts, color palette, and social assets.",
  "sp_brand_kit_feat": "Logo concepts|Color palette|Typography|Social media assets|Brand guidelines|Icon set",
  "sp_social_cal_name": "Social Media Calendar",
  "sp_social_cal_desc": "30 days of intelligently generated social media posts with engagement strategy.",
  "sp_social_cal_feat": "30-day calendar|Post copy|Hashtag strategy|Engagement tips|Best posting times|Platform optimization",
  "sp_translation_name": "Smart Translation",
  "sp_translation_desc": "Professional document translation in 50+ languages with cultural adaptation.",
  "sp_translation_feat": "50+ languages|Cultural adaptation|Technical terms|Quick turnaround|Proofreading|Format preservation",
  "sp_video_script_name": "Smart Video Script Writer",
  "sp_video_script_desc": "Engaging video scripts for YouTube, TikTok, and ads optimized for maximum engagement.",
  "sp_video_script_feat": "YouTube scripts|TikTok content|Ad copy|Hook optimization|CTA placement|Engagement tips",
  "sp_free_seo_name": "Free SEO Audit",
  "sp_free_seo_desc": "Run a free comprehensive SEO audit on any website to discover optimization opportunities.",
  "sp_free_seo_feat": "Instant results|100+ checks|Performance score|Mobile check|Security scan|Free report",
  "sp_free_tools_name": "Free Digital Tools",
  "sp_free_tools_desc": "Access our collection of free tools including color palettes, headline analyzers, and more.",
  "sp_free_tools_feat": "Color palette generator|Headline analyzer|Password generator|QR code maker|Unit converter|No signup needed",
  "sp_tools_title": "Smart Micro-Services",
  "sp_tools_desc": "Instant intelligent services for content creation, branding, analysis, and professional documents.",
  "sp_free_title": "Free Tools",
  "sp_free_desc": "Try our platform with these free tools. No account required.",
  "admin_chat_analytics": "Chat Analytics",
  "admin_ab_testing": "A/B Testing",
  "admin_ui_toggles": "UI Toggles",
  "admin_audit_trail": "Audit Trail",
  "admin_adv_reports": "Advanced Reports",
  "admin_rate_limiting": "Rate Limiting",
  "admin_email_builder": "Email Builder",
  "admin_rbac": "Access Control",
  "admin_social_auto": "Social Automation",
  "admin_health_monitor": "Health Monitoring",
  "support_tickets": "Support Tickets",
  "admin_support_tickets": "Support Tickets",
  "admin_auto_translate": "Auto Translate",
  "admin_analytics_widget": "Analytics Widget",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "White Label",
  "admin_doc_mgmt": "Documents",
  "admin_project_mgmt": "Project Mgmt",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "AI Prospecting",
  "admin_multi_tenant": "Multi-Tenant",
  "popular_services": "Popular Services",
  "popular_services_desc": "Most requested by our clients",
  "purchases": "Purchases",
  "admin_funnel": "Conversion Funnel",
  "admin_wl_licensing": "SaaS Licensing",
  "admin_analytics_export": "Analytics Export",
  "service_detail_features": "What's Included",
  "service_detail_related": "Related Services",
  "service_detail_back": "All Services",
  "checkout_currency": "Checkout Currency",
  "upsell_title": "Complete your setup",
  "upsell_desc": "Clients who purchased similar also added:",
  "cart_checkout": "Checkout",
  "cart_empty": "Your cart is empty",
  "push_notifications": "Push Notifications",
  "push_enabled": "Notifications enabled",
  "push_disabled": "Enable notifications",
  "blog_ai_generate": "AI Generate",
  "blog_gen_service": "Generate for Service",
  "blog_generating": "Generating...",
  "export_revenue": "Revenue Report",
  "export_funnel": "Conversion Funnel",
  "export_users": "User List",
  "export_pdf": "Executive Summary",
  "license_generate": "Generate License",
  "license_revoke": "Revoke",
  "license_renew": "Renew",
  "license_validate": "Validate",
  "tier_starter": "Starter",
  "tier_professional": "Professional",
  "tier_enterprise": "Enterprise",
  "blog_subtitle": "Insights, updates, and guides from Infinity Business.",
  "blog_search_placeholder": "Search articles...",
  "blog_all": "All",
  "blog_no_posts": "No posts found. Check back soon!",
  "blog_prev": "Previous",
  "blog_next": "Next",
  "blog_back": "Back to Blog",
  "micro_tools": "Smart Micro Tools",
  "micro_tools_title": "Smart Micro Tools",
  "micro_tools_subtitle": "Free AI-powered micro tools for your business",
  "color_palette_title": "Color Palette Generator",
  "color_palette_desc": "Generate beautiful color palettes for your brand",
  "color_palette_generate": "Generate Palette",
  "color_palette_copy": "Copy",
  "color_palette_copied": "Copied!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Complementary",
  "color_palette_analogous": "Analogous",
  "color_palette_triadic": "Triadic",
  "color_palette_monochromatic": "Monochromatic",
  "admin_menu_overview": "Overview",
  "admin_menu_users": "Users",
  "admin_menu_blog": "Blog Manager",
  "admin_menu_analytics": "Analytics",
  "admin_menu_settings": "Settings",
  "admin_menu_services": "Services",
  "admin_menu_chat": "Chat Sessions",
  "admin_menu_notifications": "Notifications",
  "admin_menu_support": "Support",
  "admin_menu_security": "Security",
  "admin_menu_backup": "Backup",
  "admin_menu_revenue": "Revenue",
  "admin_menu_funnel": "Funnel",
  "admin_menu_invoicing": "Invoicing",
  "admin_menu_projects": "Projects",
  "admin_menu_email": "Email Builder",
  "admin_menu_ai_config": "AI Config",
  "admin_menu_live_analytics": "Live Analytics",
  "admin_menu_platform_audit": "Platform Audit",
  "docs_title": "Documentation",
  "docs_subtitle": "Learn how to use our platform and services",
  "try_free_title": "Try Free",
  "try_free_subtitle": "Experience our services at no cost",
  "subscription_title": "Subscription Plans",
  "subscription_subtitle": "Choose the plan that fits your needs",
  "portfolio_title": "Portfolio",
  "portfolio_subtitle": "Our work speaks for itself",
  "svc_web-dev_label": "Web Development",
  "svc_web-dev_desc": "Custom websites, landing pages, and web applications",
  "svc_mobile-app_label": "Mobile App Development",
  "svc_mobile-app_desc": "iOS & Android apps, cross-platform solutions",
  "svc_graphic-design_label": "Graphic Design",
  "svc_graphic-design_desc": "Logos, branding, marketing materials",
  "svc_custom-software_label": "Custom Software",
  "svc_custom-software_desc": "Tailored business automation and enterprise tools",
  "svc_ai-business-plan_label": "Smart Business Plan Generator",
  "svc_ai-business-plan_desc": "Full business plan with financials and market analysis",
  "svc_ai-seo-report_label": "Website Audit & SEO Report",
  "svc_ai-seo-report_desc": "Automated site analysis with actionable recommendations",
  "svc_ai-email-campaign_label": "Email Marketing Setup",
  "svc_ai-email-campaign_desc": "Smart system writes copy and sets up email sequences",
  "svc_ai-competitor-analysis_label": "Competitor Analysis Report",
  "svc_ai-competitor-analysis_desc": "Market intelligence and competitive positioning",
  "svc_ai-legal-docs_label": "Legal Document Generator",
  "svc_ai-legal-docs_desc": "NDA, contracts, Terms of Service templates",
  "svc_crypto-education_label": "Crypto Education",
  "svc_crypto-education_desc": "Learn blockchain, DeFi, and crypto fundamentals",
  "svc_investment-tools_label": "Investment Tools",
  "svc_investment-tools_desc": "Portfolio tracking and market analysis dashboards",
  "svc_defi-solutions_label": "DeFi Solutions",
  "svc_defi-solutions_desc": "Smart contracts, yield farming, liquidity pools",
  "svc_personal-advertising_label": "Personal Branding",
  "svc_personal-advertising_desc": "Build your online presence and personal brand",
  "svc_ai-resume_label": "Smart Resume Builder",
  "svc_ai-resume_desc": "ATS-optimized resumes crafted by intelligent system",
  "svc_ai-brand-kit_label": "Smart Logo & Brand Kit",
  "svc_ai-brand-kit_desc": "Logo concept, color palette, typography, and social assets",
  "svc_ai-social-calendar_label": "Social Media Calendar & Analysis",
  "svc_ai-social-calendar_desc": "30 days of AI-generated posts with engagement strategy",
  "svc_ai-translation_label": "Smart Translation Service",
  "svc_ai-translation_desc": "Professional document translation in 50+ languages",
  "svc_ai-video-script_label": "Smart Video Script Writer",
  "svc_ai-video-script_desc": "YouTube, TikTok, and ad scripts optimized for engagement",
  "admin_grp_dashboard": "Dashboard",
  "admin_grp_users": "Users & Access",
  "admin_grp_analytics": "Analytics & Reports",
  "admin_grp_services": "Services & Pricing",
  "admin_grp_crypto": "Crypto & DeFi",
  "admin_grp_leads": "Leads & CRM",
  "admin_grp_content": "Content",
  "admin_grp_comm": "Communication",
  "admin_grp_social": "Social Media",
  "admin_grp_ai": "AI & Automation",
  "admin_grp_design": "Design & Branding",
  "admin_grp_system": "System",
  "admin_grp_projects": "Projects & QA",
  "color_palette_professional": "Professional",
  "color_palette_playful": "Playful",
  "color_palette_luxury": "Luxury",
  "color_palette_nature": "Nature",
  "color_palette_tech": "Tech",
  "color_palette_warm": "Warm",
  "color_palette_cool": "Cool",
  "blog_translating": "Translating article...",
  "blog_translated_cached": "Translated",
  "blog_translated_fresh": "Just translated",
  "blog_show_original": "Show original",
  "admin_ad_generator": "Ad Generator",
  "admin_add": "Add",
  "admin_add_prompt": "Add Prompt",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Advanced Reporting",
  "admin_all": "All",
  "admin_analytics_dashboard": "Analytics Dashboard",
  "admin_api_key": "API Key",
  "admin_apply": "Apply",
  "admin_approved": "Approved",
  "admin_archive": "Archive",
  "admin_are_you_sure": "Are you sure?",
  "admin_audit_alerts": "Audit Alerts",
  "admin_author": "Author",
  "admin_avg_session": "Average Session",
  "admin_back": "Back",
  "admin_badge": "Badge",
  "admin_balance": "Balance",
  "admin_banned": "Banned",
  "admin_blog_manager": "Blog Manager",
  "admin_body": "Body",
  "admin_bounce_rate": "Bounce Rate",
  "admin_browser": "Browser",
  "admin_campaign": "Campaign",
  "admin_cannot_undo": "This action cannot be undone",
  "admin_category": "Category",
  "admin_click_rate": "Click Rate",
  "admin_close": "Close",
  "admin_completed": "Completed",
  "admin_configuration": "Configuration",
  "admin_confirm": "Confirm",
  "admin_contact_info": "Contact Info",
  "admin_content": "Content",
  "admin_conversations": "Conversations",
  "admin_conversion_funnel": "Conversion Funnel",
  "admin_conversion_rate": "Conversion Rate",
  "admin_copied": "Copied to clipboard",
  "admin_copy": "Copy",
  "admin_count": "Count",
  "admin_country": "Country",
  "admin_create": "Create",
  "admin_create_experiment": "Create Experiment",
  "admin_create_new": "Create New",
  "admin_created_success": "Created successfully",
  "admin_credit_config": "Credit Configuration",
  "admin_critical": "Critical",
  "admin_custom": "Custom",
  "admin_daily": "Daily",
  "admin_date": "Date",
  "admin_delete_failed": "Failed to delete",
  "admin_deleted_success": "Deleted successfully",
  "admin_demo_access": "Demo Access",
  "admin_description": "Description",
  "admin_deselect_all": "Deselect All",
  "admin_details": "Details",
  "admin_device": "Device",
  "admin_disable": "Disable",
  "admin_disabled": "Disabled",
  "admin_doc_viewer": "Document Viewer",
  "admin_documentation": "Documentation",
  "admin_download": "Download",
  "admin_draft": "Draft",
  "admin_duplicate": "Duplicate",
  "admin_email": "Email",
  "admin_enable": "Enable",
  "admin_enabled": "Enabled",
  "admin_end_date": "End Date",
  "admin_endpoint": "Endpoint",
  "admin_error": "Error",
  "admin_escalation_queue": "Escalation Queue",
  "admin_event": "Event",
  "admin_events": "Events",
  "admin_experiment_name": "Experiment Name",
  "admin_export": "Export",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "False",
  "admin_filter": "Filter",
  "admin_frequency": "Frequency",
  "admin_generate": "Generate",
  "admin_headers": "Headers",
  "admin_health_monitoring": "Health Monitoring",
  "admin_high": "High",
  "admin_high_value_leads": "High-Value Leads",
  "admin_id": "ID",
  "admin_image": "Image",
  "admin_import": "Import",
  "admin_in_progress": "In Progress",
  "admin_inactive": "Inactive",
  "admin_inbox": "Admin Inbox",
  "admin_speed_audit": "Speed Audit",
  "admin_info": "Info",
  "admin_ip_address": "IP Address",
  "admin_joined": "Joined",
  "admin_knowledge_base": "Knowledge Base",
  "admin_language": "Language",
  "admin_last_activity": "Last Activity",
  "admin_last_login": "Last Login",
  "admin_last_triggered": "Last Triggered",
  "admin_lead_score": "Lead Score",
  "admin_level": "Level",
  "admin_load_failed": "Failed to load",
  "admin_loading_data": "Loading data...",
  "admin_low": "Low",
  "admin_medium": "Medium",
  "admin_messages": "Messages",
  "admin_method": "Method",
  "admin_monetization": "Monetization",
  "admin_monthly": "Monthly",
  "admin_name": "Name",
  "admin_next": "Next",
  "admin_no": "No",
  "admin_no_data_available": "No data available",
  "admin_no_experiments": "No experiments found",
  "admin_no_leads": "No leads found",
  "admin_no_prompts": "No prompts found",
  "admin_no_results": "No results",
  "admin_no_results_found": "No results found",
  "admin_none": "None",
  "admin_off": "Off",
  "admin_on": "On",
  "admin_open_rate": "Open Rate",
  "admin_page_views": "Page Views",
  "admin_partner_badges": "Partner Badges",
  "admin_payload": "Payload",
  "admin_payment_options": "Payment Options",
  "admin_platform": "Platform",
  "admin_platform_audit": "Platform Audit",
  "admin_points": "Points",
  "admin_portfolio_manager": "Portfolio Manager",
  "admin_preloader_config": "Preloader Config",
  "admin_preview": "Preview",
  "admin_previous": "Previous",
  "admin_price": "Price",
  "admin_priority": "Priority",
  "admin_prompt_name": "Prompt Name",
  "admin_prompt_text": "Prompt Text",
  "admin_published": "Published",
  "admin_recipients": "Recipients",
  "admin_referral": "Referral",
  "admin_referral_leaderboard": "Referral Leaderboard",
  "admin_refresh": "Refresh",
  "admin_rejected": "Rejected",
  "admin_remove": "Remove",
  "admin_reset": "Reset",
  "admin_response_time": "Response Time",
  "admin_restore": "Restore",
  "admin_results": "Results",
  "admin_retry": "Retry",
  "admin_revenue_dashboard": "Revenue Dashboard",
  "admin_rista_services": "RisTA Services",
  "admin_role": "Role",
  "admin_save_changes": "Save Changes",
  "admin_save_failed": "Failed to save",
  "admin_saved_success": "Saved successfully",
  "admin_scheduled": "Scheduled",
  "admin_search": "Search",
  "admin_select": "Select",
  "admin_select_all": "Select All",
  "admin_send": "Send",
  "admin_sent_success": "Sent successfully",
  "admin_server_resources": "Server Resources",
  "admin_service_manager": "Service Manager",
  "admin_session_duration": "Session Duration",
  "admin_settings": "Settings",
  "admin_slug": "Slug",
  "admin_social_automation": "Social Automation",
  "admin_something_wrong": "Something went wrong",
  "admin_source": "Source",
  "admin_start_date": "Start Date",
  "admin_subject": "Subject",
  "admin_submit": "Submit",
  "admin_subscribers": "Subscribers",
  "admin_success": "Success",
  "admin_suspended": "Suspended",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Tags",
  "admin_template": "Template",
  "admin_templates": "Templates",
  "admin_test_results": "Test Results",
  "admin_tester_program": "Tester Program",
  "admin_title": "Title",
  "admin_total_revenue": "Total Revenue",
  "admin_total_sessions": "Total Sessions",
  "admin_total_users": "Total Users",
  "admin_trigger": "Trigger",
  "admin_true": "True",
  "admin_try_again": "Please try again",
  "admin_type": "Type",
  "admin_unique_visitors": "Unique Visitors",
  "admin_unsubscribed": "Unsubscribed",
  "admin_unverified": "Unverified",
  "admin_update": "Update",
  "admin_updated_success": "Updated successfully",
  "admin_upload": "Upload",
  "admin_urgent": "Urgent",
  "admin_user": "User",
  "admin_variant_a": "Variant A",
  "admin_variant_b": "Variant B",
  "admin_verified": "Verified",
  "admin_version": "Version",
  "admin_view": "View",
  "admin_view_details": "View Details",
  "admin_viewer": "Viewer",
  "admin_warning": "Warning",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Weekly",
  "admin_yes": "Yes",
  "admin_analytics_digestadmin_analytics_digest": "Analytics Digest",
  "admin_analytics_digest": "Analytics Digest",
  "admin_seo_suggestions": "SEO Optimization",
  "admin_visitor_map": "Visitor Map",
  "admin_competitor_monitor": "Competitor Intelligence",
  "admin_email_workflows": "Email Workflows",
  "admin_collab_editing": "Team Collaboration",
  "admin_blog_health": "Blog Health",
  "credit_title": "Credits",
  "credit_subtitle": "Prepaid balance for intelligent services",
  "credit_available_balance": "Available Balance",
  "credit_tab_balance": "Balance",
  "credit_tab_topup": "Top Up",
  "credit_tab_history": "History",
  "credit_tab_services": "Services",
  "credit_tab_crypto": "Crypto",
  "credit_balance_desc": "Your credit can be used for any intelligent-system-powered service:",
  "credit_bulk_discounts": "Bulk Discounts",
  "credit_add_credits": "Add Credits",
  "credit_select_amount": "Select an amount or enter a custom value:",
  "credit_bonus": "bonus",
  "credit_bonus_detail": "You'll get",
  "credit_total_word": "total",
  "credit_method_card": "Card",
  "credit_method_crypto": "Crypto",
  "credit_processing": "Processing...",
  "credit_add_btn": "Add",
  "credit_no_txn": "No transactions yet",
  "credit_txn_topup": "Top-up",
  "credit_txn_promo": "Promo Credit",
  "credit_txn_auto": "Auto Purchase",
  "credit_txn_purchase": "Purchase",
  "credit_svc_intelligent": "Intelligent service",
  "credit_svc_available": "Available",
  "credit_svc_need_more": "Need",
  "credit_svc_more": "more",
  "credit_crypto_send": "Send",
  "credit_crypto_amount": "Amount:",
  "credit_crypto_equivalent": "equivalent",
  "credit_crypto_network": "Network:",
  "credit_crypto_wallet": "Wallet Address",
  "credit_crypto_confirm": "Credits will be added once we confirm the transaction.",
  "credit_payment_id": "Payment ID:",
  "credit_crypto_back": "Back to crypto selection",
  "credit_crypto_select_title": "Select Cryptocurrency for Top-Up",
  "credit_crypto_choose_desc": "Choose a coin below. You'll receive a wallet address to send payment.",
  "credit_crypto_select_btn": "Select",
  "credit_minimum": "Minimum is €5",
  "credit_redirecting": "Redirecting...",
  "credit_topup_failed": "Top-up failed",
  "credit_crypto_failed": "Failed to initiate crypto payment",
  "cart_title": "Cart",
  "cart_total": "Total",
  "cart_stripe_checkout": "Stripe Checkout",
  "cart_credits": "Credits",
  "cart_secure_stripe": "Secure Stripe checkout",
  "cart_insufficient": "Insufficient credits. Top up first or choose card payment.",
  "cart_pay_card": "Pay with Card",
  "cart_pay_credits_btn": "Pay with Credits",
  "cart_clear": "Clear cart",
  "cart_processing": "Processing...",
  "cart_payment_success": "Payment successful! Your order is being processed.",
  "cart_complete_setup": "Complete your setup",
  "cart_also_added": "Clients who purchased similar services also added:",
  "cart_add": "Add",
  "cart_standard": "Standard",
  "cart_remaining_balance": "Remaining balance:",
  "cart_checkout_failed": "Checkout failed",
  "cart_checkout_no_session": "Could not create checkout session",
  "cart_purchased": "Purchased",
  "cart_services_with_credits": "service(s) with credits!",
  "credits_balance_title": "Credit Balance",
  "credits_topup_btn": "Top Up Credits",
  "credits_rate": "1 EUR = 1 Credit",
  "credits_total_topup": "Total Topped Up",
  "credits_spent_credits": "Spent (Credits)",
  "credits_spent_payments": "Spent (Payments)",
  "credits_txn_history": "Transaction History",
  "credits_no_txn": "No transactions yet",
  "credits_txn_topup": "Top-up",
  "credits_txn_promo": "Promo Credit",
  "credits_txn_purchase": "Service Purchase",
  "credits_txn_ai": "Smart Service",
  "credits_order_history": "Order History",
  "credits_order_label": "Order:",
  "chat_translate_btn": "Translate to English",
  "chat_translating": "Translating...",
  "chat_translated_label": "Showing English translation. Click \"Show Original\" to see the original messages.",
  "chat_show_original": "Show Original",
  "chat_show_translated": "Show Translated",

  // Package Manager & Landing Packages
  "pkg_section_badge": "Limited-Time Offers",
  "pkg_section_title": "Launch Your Business",
  "pkg_section_title_highlight": "Today",
  "pkg_section_subtitle": "Premium packages designed to get you online fast — with intelligent technology built in from day one.",
  "pkg_section_footer": "All prices exclude VAT where applicable. Not sure which package fits? Chat with RisTA for a free consultation.",
  "pkg_cta_default": "Get Started",
  "admin_package_mgr": "Package Manager",
  "admin_pkg_title": "Landing Page Packages",
  "admin_pkg_subtitle": "Manage highlighted pricing packages shown on the landing page",
  "admin_pkg_seed": "Seed Defaults",
  "admin_pkg_new": "New Package",
  "admin_pkg_create_title": "Create New Package",
  "admin_pkg_edit_title": "Edit Package",
  "admin_pkg_name": "Package Name",
  "admin_pkg_tagline": "Tagline",
  "admin_pkg_description": "Description",
  "admin_pkg_price": "Price",
  "admin_pkg_currency": "Currency",
  "admin_pkg_price_note": "Price Note",
  "admin_pkg_badge": "Badge",
  "admin_pkg_accent": "Accent Color",
  "admin_pkg_cta_text": "CTA Button Text",
  "admin_pkg_cta_link": "CTA Link (optional)",
  "admin_pkg_sort": "Sort Order",
  "admin_pkg_features": "Features / Services Included",
  "admin_pkg_add_feature": "Add Feature",
  "admin_pkg_highlighted": "Highlighted",
  "admin_pkg_normal": "Normal",
  "admin_pkg_create": "Create Package",
  "admin_pkg_save": "Save Changes",
  "admin_pkg_saving": "Saving...",
  "admin_pkg_cancel": "Cancel",
  "admin_pkg_empty_title": "No packages configured yet",
  "admin_pkg_empty_desc": "Click Seed Defaults to generate two starter packages, or create your own.",
  "admin_pkg_features_label": "features",
  "admin_pkg_sort_label": "Sort",
  "admin_pkg_delete_confirm": "Delete this package? It will be removed from the landing page.",
  "admin_pkg_feature_placeholder": "Feature description...",
  "admin_pkg_pricenote_placeholder": "e.g. One-time / +5% rev share",
  "admin_pkg_badge_placeholder": "e.g. BEST VALUE",
  "admin_pkg_loading": "Loading packages...",
  "pkg_qa_have_domain": "Yes, I have a domain",
  "pkg_qa_need_domain": "I need a domain",
  "pkg_qa_describe_biz": "Let me describe my business",
  "pkg_qa_more_info": "Tell me more about this package",
  "admin_status_online": "Online",
  "admin_status_offline": "Offline",
  "admin_status_online_desc": "You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "AI Model",
  "admin_prompts": "Prompts",
  "admin_no_escalations": "No escalations in queue.",
  "blog_edit": "Edit Post",
  "admin_card_visibility": "Card Visibility",

  "sp_managed_hosting": "Managed Hosting",
  "sp_managed_hosting_name": "Managed Hosting",
  "sp_managed_hosting_desc": "Fully managed hosting with monitoring, updates, and dedicated support.",
  "sp_managed_hosting_feat": "24/7 monitoring|Automatic updates|SSL management|Daily backups|Performance optimization|Dedicated support",
  "sp_enterprise_ad": "Enterprise Advertising",
  "sp_enterprise_ad_name": "Enterprise Advertising",
  "sp_enterprise_ad_desc": "Large-scale advertising campaigns with dedicated strategy and management.",
  "sp_enterprise_ad_feat": "Campaign strategy|Multi-channel ads|A/B testing|Performance tracking|Dedicated manager|Custom reporting",
  "sp_email_marketing": "Email Marketing Setup",
  "sp_email_marketing_name": "Email Marketing Setup",
  "sp_email_marketing_desc": "Professional email sequences, templates, and marketing automation.",
  "sp_email_marketing_feat": "Email sequences|Template design|Automation setup|List management|Analytics|A/B testing",
  "sp_competitor_analysis": "Competitor Analysis Report",
  "sp_competitor_analysis_name": "Competitor Analysis Report",
  "sp_competitor_analysis_desc": "In-depth market intelligence and competitive positioning insights.",
  "sp_competitor_analysis_feat": "Market mapping|Competitor profiling|SWOT analysis|Pricing comparison|Strategy recommendations|Monthly updates",
  "sp_website_audit": "Website Audit & SEO Report",
  "sp_website_audit_name": "Website Audit & SEO Report",
  "sp_website_audit_desc": "Comprehensive site analysis with actionable improvement recommendations.",
  "sp_website_audit_feat": "Technical audit|SEO analysis|Performance metrics|Accessibility check|Security scan|Action plan",
  "sp_managed_trading": "Managed Trading",
  "sp_managed_trading_name": "Managed Trading",
  "sp_managed_trading_desc": "Expert-managed trading with proven strategies and risk management.",
  "sp_managed_trading_feat": "Expert portfolio management|Risk management|Proven strategies|Regular reporting|Dedicated manager|Market analysis",
  "sp_trading_consult": "Trading Consultations",
  "sp_trading_consult_name": "Trading Consultations",
  "sp_trading_consult_desc": "Expert-guided trading strategy sessions, one-on-one.",
  "sp_trading_consult_feat": "One-on-one sessions|Strategy development|Market analysis|Risk assessment|Portfolio review|Expert guidance",
  "sp_domains": "LiveDomain Aftermarket",
  "sp_domains_name": "LiveDomain Aftermarket",
  "sp_domains_desc": "Premium domain acquisition and aftermarket deals.",
  "sp_domains_feat": "Premium domains|Aftermarket deals|Domain valuation|Transfer support|Negotiation|Portfolio management",
  "sp_domain_mgmt": "Domain Management",
  "sp_domain_mgmt_name": "Domain Management",
  "sp_domain_mgmt_desc": "DNS management, renewals, transfers, and domain portfolio care.",
  "sp_domain_mgmt_feat": "DNS management|Auto-renewals|Transfer support|Portfolio tracking|SSL certificates|Whois privacy",
  "sp_defi": "DeFi Solutions",
  "sp_defi_name": "DeFi Solutions",
  "sp_defi_desc": "Smart contracts, yield farming, and liquidity pool solutions.",
  "sp_defi_feat": "Smart contracts|Yield farming|Liquidity pools|DeFi auditing|Token creation|Staking solutions",
  "sp_personal_brand": "Personal Branding",
  "sp_personal_brand_name": "Personal Branding",
  "sp_personal_brand_desc": "Build your online presence and personal brand identity.",
  "sp_personal_brand_feat": "Brand strategy|Social media presence|Personal website|Content planning|Professional photos|Bio writing",
  "sp_ad_gen": "Ad Generator",
  "sp_ad_gen_name": "Ad Generator",
  "sp_ad_gen_desc": "Generate high-converting ad copy and creatives instantly.",
  "sp_ad_gen_feat": "Ad copy generation|Creative formats|Multi-platform|A/B variants|Audience targeting|Performance tips",
  "sp_priority": "Priority Queue",
  "sp_priority_name": "Priority Queue",
  "sp_priority_desc": "Get a response within 4 hours guaranteed.",
  "sp_priority_feat": "4-hour response time|Dedicated channel|Priority processing|Status updates|SLA guarantee|Extended support",
  "sp_maintenance": "Maintenance Plan",
  "sp_maintenance_name": "Maintenance Plan",
  "sp_maintenance_desc": "Ongoing maintenance, updates, and technical support.",
  "sp_maintenance_feat": "Monthly updates|Security patches|Performance monitoring|Bug fixes|Uptime guarantee|Priority support",
  "sp_consulting": "Smart Consulting Session",
  "sp_consulting_name": "Smart Consulting Session",
  "sp_consulting_desc": "One-on-one consulting with our smart technology experts.",
  "sp_consulting_feat": "Expert consultation|Strategy session|Technical advice|Implementation plan|Follow-up notes|Recording provided",
  "sp_market_snapshot": "Market Snapshot",
  "sp_market_snapshot_name": "Market Snapshot",
  "sp_market_snapshot_desc": "Quick overview of your market landscape and trends.",
  "sp_market_snapshot_feat": "Market overview|Key trends|Competitor landscape|Growth opportunities|Risk factors|Executive summary",
  "sp_trend_explainer": "Trend Explainer",
  "sp_trend_explainer_name": "Trend Explainer",
  "sp_trend_explainer_desc": "Understand emerging trends relevant to your industry.",
  "sp_trend_explainer_feat": "Trend analysis|Industry impact|Opportunity assessment|Timeline projection|Action items|Visual report",
  "sp_competitor_qa": "Competitor Q&A",
  "sp_competitor_qa_name": "Competitor Q&A",
  "sp_competitor_qa_desc": "Get answers about your competitors' strategies.",
  "sp_competitor_qa_feat": "Strategy analysis|Pricing insights|Market positioning|Feature comparison|Weakness analysis|Opportunity map",
  "sp_country_entry": "Country Entry Check",
  "sp_country_entry_name": "Country Entry Check",
  "sp_country_entry_desc": "Evaluate market readiness for international expansion.",
  "sp_country_entry_feat": "Market readiness|Regulatory overview|Cultural factors|Competition analysis|Entry strategy|Risk assessment",
  "sp_vendor_shortlist": "Vendor Shortlist Draft",
  "sp_vendor_shortlist_name": "Vendor Shortlist Draft",
  "sp_vendor_shortlist_desc": "Curated vendor shortlist for your specific needs.",
  "sp_vendor_shortlist_feat": "Vendor research|Comparison matrix|Pricing analysis|Capability assessment|Recommendations|Contact details",
  "sp_tam_logic": "Quick TAM Logic Sketch",
  "sp_tam_logic_name": "Quick TAM Logic Sketch",
  "sp_tam_logic_desc": "Total addressable market estimation with logic breakdown.",
  "sp_tam_logic_feat": "TAM estimation|SAM/SOM breakdown|Logic framework|Data sources|Growth assumptions|Visual presentation",
  "sp_positioning": "Positioning Angle",
  "sp_positioning_name": "Positioning Angle",
  "sp_positioning_desc": "Product + audience positioning strategy analysis.",
  "sp_positioning_feat": "Market positioning|Audience segmentation|Value proposition|Messaging framework|Differentiation|Competitive edge",
  "sp_addon_title": "Add-ons & Support",
  "sp_addon_desc": "Boost your project with priority support, maintenance, and expert consulting.",
  "sp_research_title": "Smart Research Products",
  "sp_research_desc": "On-demand market intelligence and research tools powered by smart analysis.",

  "tier_section_badge": "Smart Packages",
  "tier_section_title": "Choose Your",
  "tier_section_highlight": "Growth Plan",
  "tier_section_subtitle": "Bundled packages designed to deliver maximum value. Pick the tier that fits your stage.",
  "tier_one_time": "One-Time",
  "tier_monthly": "Monthly",
  "tier_section_footer": "All prices exclude VAT where applicable. Need a custom package? Chat with RisTA for a tailored solution.",

  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Perfect for getting started with your digital presence",
  "tier_tag_growth": "Scale your business with smart tools and marketing",
  "tier_tag_pro": "Full-stack digital growth for serious businesses",
  "tier_tag_enterprise": "Complete digital transformation for your business",
  "tier_cta_starter": "Get Starter",
  "tier_cta_growth": "Get Growth",
  "tier_cta_pro": "Get Pro",
  "tier_cta_enterprise": "Get Enterprise",
  "tier_badge_popular": "POPULAR",
  "tier_badge_best": "BEST VALUE",
  "tier_badge_all": "ALL-IN-ONE",
  "tier_per_mo": "mo",
  "tier_once_label": "one-time",
  "tier_or_monthly": "or",

  "tier_f_starter_1": "Smart Business Plan Generator",
  "tier_f_starter_2": "Smart Resume Builder (3 resumes)",
  "tier_f_starter_3": "Website Audit & SEO Report",
  "tier_f_starter_4": "Smart Logo and Brand Kit",
  "tier_f_starter_5": "Market Snapshot Report",
  "tier_f_starter_6": "FAQ Answer Draft",
  "tier_f_starter_7": "Blog Outline from Trend",
  "tier_f_starter_8": "Email support within 48h",
  "tier_f_growth_1": "Everything in Starter",
  "tier_f_growth_2": "Smart Email Campaign",
  "tier_f_growth_3": "Social Media Calendar & Analysis (3 mo)",
  "tier_f_growth_4": "Competitor Analysis Report",
  "tier_f_growth_5": "Ad Generator (5 campaigns)",
  "tier_f_growth_6": "Outreach Email Generator",
  "tier_f_growth_7": "Trend Explainer",
  "tier_f_growth_8": "Positioning Angle Analysis",
  "tier_f_growth_9": "Priority email support within 24h",
  "tier_f_pro_1": "Everything in Growth",
  "tier_f_pro_2": "SEO & Digital Marketing Setup",
  "tier_f_pro_3": "Email Marketing Setup",
  "tier_f_pro_4": "Smart Video Script Writer (5 scripts)",
  "tier_f_pro_5": "Quick TAM Logic Sketch",
  "tier_f_pro_6": "Risk Checklist",
  "tier_f_pro_7": "Feature Prioritization Nudge",
  "tier_f_pro_8": "Vendor Shortlist Draft",
  "tier_f_pro_9": "Smart Consulting Session (2 hours)",
  "tier_f_pro_10": "Priority support within 12h",
  "tier_f_ent_1": "Everything in Pro",
  "tier_f_ent_2": "Custom Software Development",
  "tier_f_ent_3": "Enterprise Advertising Strategy",
  "tier_f_ent_4": "Managed Hosting (12 months)",
  "tier_f_ent_5": "Maintenance Plan (6 months)",
  "tier_f_ent_6": "Smart Consulting (10 hours)",
  "tier_f_ent_7": "Country Entry Check",
  "tier_f_ent_8": "Executive Summary for Slides",
  "tier_f_ent_9": "JTBD Problem Statement",
  "tier_f_ent_10": "Dedicated account manager",
  "tier_f_ent_11": "Priority Queue (4h response)",

  "calc_title": "Pricing Calculator",
  "calc_subtitle": "Compare individual services vs. bundled tier packages to see your savings.",
  "calc_badge": "Save More",
  "calc_select_services": "Select Services",
  "calc_search_placeholder": "Search services...",
  "calc_selected": "selected",
  "calc_your_selection": "Your Selection",
  "calc_individual_total": "Individual Total",
  "calc_best_tier": "Best Matching Tier",
  "calc_you_save": "You Save",
  "calc_no_services": "Select services above to see savings",
  "calc_clear_all": "Clear All",
  "calc_get_tier": "Get This Package",
  "referred_by": "Referred by",
  "referral_signup_reward": "Sign up to connect your account with this referral.",
  "admin_vector_gen": "Vector Generator",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Landing Page",
  "admin_landing_text": "Landing Page Texts",
  "admin_vector_title": "Vector Generator",
  "admin_vector_models": "Available Models",
  "admin_vector_pricing": "Pricing & Limits",
  "vector_gen_title": "Smart Vector",
  "vector_gen_title_hl": "Generator",
  "vector_gen_badge": "Smart Vector Studio",
  "vector_gen_desc": "Describe your idea, upload references, and get a production-ready SVG vector graphic in seconds.",
  "vector_gen_balance": "Your balance",
  "vector_gen_per_gen": "credits per generation",
  "vector_gen_prompt_label": "Describe your vector graphic",
  "vector_gen_prompt_ph": "e.g., A minimalist mountain logo with sun rays, using teal and orange colors...",
  "vector_gen_style": "Style",
  "vector_gen_color": "Color Mode",
  "vector_gen_refs": "Reference Files",
  "vector_gen_optional": "optional, max 3",
  "vector_gen_upload": "Upload reference (PNG, JPG, SVG)",
  "vector_gen_generating": "Generating...",
  "vector_gen_cta": "Generate Vector",
  "vector_gen_result": "Your Vector Graphic",
  "vector_gen_model_used": "Model",
  "vector_gen_history": "Generation History",
  "vector_gen_no_history": "No generations yet",
  "vector_gen_login_req": "Please sign in to use the Vector Generator.",
  "vector_gen_service_title": "Need Professional Vectors?",
  "vector_gen_service_desc": "Order custom vector graphics as a full design service with revisions, multiple formats, and brand guidelines.",
  "vector_gen_service_cta": "View Design Services",
  "vector_gen_product_type": "Product Type",
  "vector_gen_size": "Output Size",
  "vector_gen_error_prompt": "Please describe your vector graphic idea.",
  "vector_gen_model": "Model",
  "vector_gen_quality": "Quality Level",
  "badge_coming_soon": "Coming Soon",
  "badge_available_soon": "Available Soon",
  "badge_from_price": "from",
  "from": "From",
  "badge_preparing": "We are preparing this service for you",
  "svc_managed-hosting_label": "Managed Hosting",
  "svc_managed-hosting_desc": "Fully managed hosting with monitoring and support",
  "svc_enterprise-advertising_label": "Enterprise Advertising",
  "svc_enterprise-advertising_desc": "Large-scale advertising campaigns with dedicated strategy",
  "svc_email-marketing_label": "Email Marketing Setup",
  "svc_email-marketing_desc": "Professional email sequences, templates, and automation",
  "svc_competitor-analysis_label": "Competitor Analysis Report",
  "svc_competitor-analysis_desc": "Market intelligence and competitive positioning",
  "svc_legal-docs_label": "Legal Document Generator",
  "svc_legal-docs_desc": "NDA, contracts, Terms of Service templates",
  "svc_website-audit_label": "Website Audit & SEO Report",
  "svc_website-audit_desc": "Comprehensive site analysis with actionable recommendations",
  "svc_trading-consultation_label": "Trading Consultations",
  "svc_trading-consultation_desc": "Expert-guided trading strategy sessions",
  "svc_managed-trading_label": "Managed Trading",
  "svc_managed-trading_desc": "Expert-managed trading with proven strategies",
  "svc_domain-management_label": "Domain Management",
  "svc_domain-management_desc": "Domain registration, DNS management and transfers",
  "svc_personal-branding_label": "Personal Branding",
  "svc_personal-branding_desc": "Build your online presence and personal brand",
  "svc_vector-generator_label": "Smart Vector Generator",
  "svc_vector-generator_desc": "Generate production-ready SVG vector graphics from text descriptions",
  "agency_rista_tooltip": "Chat with RisTA",
  "agency_hero_title_1": "Lightning-Fast Websites That ",
  "agency_hero_title_highlight": "Sell",
  "agency_hero_title_2": " for Local Businesses",
  "agency_hero_subtitle_1": "Get a custom site loading in milliseconds + built-in analytics for",
  "agency_hero_subtitle_2": ". No slow pages, more leads — launch in weeks.",
  "agency_hero_limited": "Limited spots!",
  "agency_hero_cta_pricing": "See €498 Package",
  "agency_hero_cta_audit": "Free Site Audit",
  "agency_trust_maintenance": "maintenance after",
  "agency_trust_efficient": "100% Efficient",
  "agency_trust_powered": "Powered by Intelligent System",
  "agency_speed_title": "Website Load Speed",
  "agency_speed_before": "Before",
  "agency_speed_after": "After",
  "agency_speed_leads": "+35% leads",
  "agency_pain_title_1": "Slow Websites ",
  "agency_pain_title_2": "Kill Sales",
  "agency_pain_subtitle": "Every second your site takes to load, you lose customers. Here's the problem — and how we fix it.",
  "agency_pain_slow_title": "Slow Loading = Lost Leads",
  "agency_pain_slow_desc": "Your website takes 5+ seconds to load. Visitors click away before seeing your offer. You're paying for traffic that never converts.",
  "agency_pain_stats_title": "47% Leave if >3s",
  "agency_pain_stats_desc": "Google research shows nearly half of visitors abandon a mobile site that takes longer than 3 seconds to load. Every millisecond matters.",
  "agency_pain_stats_source": "Source: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Our Speed-First Tech",
  "agency_pain_solution_desc": "Custom-built sites optimized to load under 1 second. Edge-cached, image-optimized, code-minimized. More speed = more leads = more revenue.",
  "agency_pricing_title": "Simple, Transparent Pricing",
  "agency_pricing_subtitle": "Choose the plan that fits your business. All plans include our speed-first technology.",
  "agency_pricing_urgency_1": "Only ",
  "agency_pricing_urgency_2": " starter spots left this month",
  "agency_pricing_popular": "MOST POPULAR",
  "agency_pricing_get_started": "Get Started",
  "agency_pricing_guarantee": "30-day money-back guarantee",
  "agency_pricing_ideal": "Ideal for:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "one-time",
  "agency_pricing_starter_ideal": "Solopreneurs",
  "agency_pricing_s_1": "Lightning-fast custom website",
  "agency_pricing_s_2": "Domain + hosting for 1 year",
  "agency_pricing_s_3": "Basic analytics dashboard",
  "agency_pricing_s_4": "Mobile-responsive design",
  "agency_pricing_s_5": "SSL certificate included",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Growing stores",
  "agency_pricing_p_1": "Everything in Starter",
  "agency_pricing_p_2": "E-commerce + cart recovery",
  "agency_pricing_p_3": "SEO optimization package",
  "agency_pricing_p_4": "A/B testing integration",
  "agency_pricing_p_5": "Priority support",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Scaling businesses",
  "agency_pricing_pr_1": "Everything in Performance",
  "agency_pricing_pr_2": "Google Ads management",
  "agency_pricing_pr_3": "Weekly performance audits",
  "agency_pricing_pr_4": "Dedicated account manager",
  "agency_pricing_pr_5": "Custom integrations",
  "agency_social_title": "Trusted by Local Businesses",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "I analyze visitor behavior in real-time to boost your conversions.",
  "agency_social_see_clients": "See what our clients say",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO, Local Shop",
  "agency_social_t1_text": "Doubled our leads in the first month! The website loads instantly and our customers love the new design. Best investment we made.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Restaurant Owner",
  "agency_social_t2_text": "Our online orders increased by 40% after the new site launched. The speed difference is night and day compared to our old WordPress site.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Fitness Studio",
  "agency_social_t3_text": "Professional, fast, and they actually deliver on their promises. Our booking rate went up 35% in just 3 weeks.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Boutique Owner",
  "agency_social_t4_text": "The e-commerce setup was seamless. Cart recovery alone paid for the Performance plan in the first quarter.",
  "agency_social_metric_1": "Avg Load Time",
  "agency_social_metric_2": "More Leads",
  "agency_social_metric_3": "Client Satisfaction",
  "agency_services_title": "Everything Your Business Needs",
  "agency_services_subtitle": "Comprehensive digital solutions to grow your online presence.",
  "agency_svc_fast_title": "Fast Websites",
  "agency_svc_fast_desc": "Custom-built sites loading under 1 second. Mobile-first, SEO-optimized, conversion-focused.",
  "agency_svc_ecom_title": "E-Commerce Stores",
  "agency_svc_ecom_desc": "Sell online with cart recovery, payment processing, and inventory management built in.",
  "agency_svc_seo_title": "SEO Audit & Optimization",
  "agency_svc_seo_desc": "Rank higher on Google. Technical SEO, content strategy, and monthly performance reports.",
  "agency_svc_ads_title": "Google Ads Setup",
  "agency_svc_ads_desc": "Get targeted traffic fast. Campaign setup, optimization, and ROI tracking included.",
  "agency_svc_maint_title": "Maintenance & Support",
  "agency_svc_maint_desc": "Hosting, security updates, backups, and content changes. Starting at €30/month.",
  "agency_faq_title": "Frequently Asked Questions",
  "agency_faq_q1": "How fast will my website load?",
  "agency_faq_a1": "Under 1 second. We optimize every millisecond — from server response to full visual render. Your visitors see content instantly.",
  "agency_faq_q2": "What is included in the €498 Starter package?",
  "agency_faq_a2": "A lightning-fast custom website, domain and hosting for 1 year, basic analytics dashboard, mobile-responsive design, and SSL certificate.",
  "agency_faq_q3": "How long does it take to launch?",
  "agency_faq_a3": "Most Starter projects launch in 2-3 weeks. Performance and Premium plans typically take 4-6 weeks depending on complexity.",
  "agency_faq_q4": "Do you offer ongoing maintenance?",
  "agency_faq_a4": "Yes. After the first year, maintenance starts at €30/month which includes hosting, security updates, backups, and minor content changes.",
  "agency_faq_q5": "Can I upgrade my plan later?",
  "agency_faq_a5": "Absolutely. You can upgrade from Starter to Performance or Premium at any time. We will credit your initial investment toward the upgrade.",
  "agency_cta_title_1": "Ready to Scale ",
  "agency_cta_title_2": "Without Limits?",
  "agency_cta_subtitle": "Tell us about your business and we'll create a custom plan to grow your online presence. Free consultation, no obligation.",
  "agency_contact_name": "Your Name",
  "agency_contact_email": "Email Address",
  "agency_contact_biz_select": "Select Business Type",
  "agency_contact_biz_restaurant": "Restaurant / Food",
  "agency_contact_biz_retail": "Retail / Shop",
  "agency_contact_biz_services": "Professional Services",
  "agency_contact_biz_fitness": "Fitness / Wellness",
  "agency_contact_biz_realestate": "Real Estate",
  "agency_contact_biz_other": "Other",
  "agency_contact_submit": "Get Free Consultation",
  "agency_contact_sent_title": "Message Sent!",
  "agency_contact_sent_desc": "We'll get back to you within 24 hours.",
  "agency_exit_title": "Wait! Free Speed Audit?",
  "agency_exit_desc": "Find out exactly how much faster your website could be. Get a detailed performance report — 100% free, no obligation.",
  "agency_exit_email": "Your email",
  "agency_exit_submit": "Send Audit",
  "agency_exit_thanks_title": "Thank You!",
  "agency_exit_thanks_desc": "We'll send your free speed audit within 24 hours.",
  "exit_owner_confirm": "I confirm that I am the owner or authorized representative of this website",
  "agency_exit_website": "Your website URL (e.g. https://example.com)",
  "trusted_partners_certifications": "Trusted Partners & Certifications",
  "agency_footer_brand_desc": "Developed, hosted and designed by Infinitybusiness.org",
  "agency_footer_services": "Services",
  "agency_footer_fast_web": "Fast Websites",
  "agency_footer_ecom": "E-Commerce Stores",
  "agency_footer_seo": "SEO Audit",
  "agency_footer_ads": "Google Ads Setup",
  "agency_footer_maint": "Maintenance",
  "agency_footer_company": "Company",
  "agency_footer_about": "About Us",
  "agency_footer_contact": "Contact",
  "agency_footer_privacy": "Privacy Policy",
  "agency_footer_terms": "Terms & Conditions",
  "agency_footer_touch": "Get in Touch",
  "agency_footer_copyright": "© 2026 Infinity Business. All rights reserved.",
  "agency_footer_dev_by": "Developed, hosted and designed by",
  "agency_footer_newsletter": "Subscribe to newsletter",
  "agency_footer_subscribe": "Subscribe",
  "agency_sticky_pricing": "See Pricing",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Explore our portfolio of website transformations. Before and after comparisons of real client projects.",
  "showroom_badge": "Our Work",
  "showroom_title_prefix": "Project",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "See real transformations. Drag the slider to compare before and after states of our client projects.",
  "showroom_search_placeholder": "Search projects...",
  "showroom_all_services": "All Services",
  "showroom_sort_newest": "Newest First",
  "showroom_sort_oldest": "Oldest First",
  "showroom_sort_name_az": "Name A-Z",
  "showroom_sort_name_za": "Name Z-A",
  "showroom_active_filters": "Active filters",
  "showroom_showing": "Showing",
  "showroom_project_singular": "project",
  "showroom_project_plural": "projects",
  "showroom_empty": "No projects in the showroom yet.",
  "showroom_no_match": "No projects match your filters.",
  "showroom_features_built": "Features Built",
  "showroom_visit_live": "Visit Live Site",
}
